import { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useGetInventorySpareLotByIdQuery,
  useUpdateInventorySpareLotMutation,
} from "../../../../../services/inventory/spares/inventorySpareLotListApiSlice";
import { LotDetailForm } from "../../../../../component/inventory/spares/lot/lotDetail/LotDetailForm";

import classes from "./inventorySparesLotItemDetailPage.module.css";

import {
  XCircleIcon,
  CheckCircleIcon,
  ClockIcon,
} from "@heroicons/react/24/solid";

const statusConfig = {
  0: {
    label: "No Image",
    bg: "#FDECEC",
    color: "#E53935",
    Icon: XCircleIcon,
  },
  1: {
    label: "Image Exists",
    bg: "#E6F7EF",
    color: "#00A167",
    Icon: CheckCircleIcon,
  },
  2: {
    label: "Scanning",
    bg: "#FFF4E5",
    color: "#FAAD14",
    Icon: ClockIcon,
  },
};

const ImageStatusBadge = ({ status }) => {
  const config = statusConfig[status] || statusConfig[0];
  const { label, bg, color, Icon } = config;

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        padding: "8px 14px",
        borderRadius: "999px",
        fontSize: "14px",
        fontWeight: 500,
        fontFamily: "Poppins, system-ui, -apple-system, BlinkMacSystemFont",
        backgroundColor: bg,
        color: color,
        whiteSpace: "nowrap",
      }}
    >
      <Icon style={{ width: 14, height: 14 }} />
      {label}
    </div>
  );
};

export const InventorySparesLotItemDetailPage = () => {
  const { inventoryId, lotItemId } = useParams();

  const { data: lotItemData } = useGetInventorySpareLotByIdQuery(
    {
      inventory_id: inventoryId,
      request_id: lotItemId,
    },
    { skip: !inventoryId || !lotItemId }
  );

  const [isHotSelling, setIsHotSelling] = useState(false);
  const [updateLot] = useUpdateInventorySpareLotMutation();

  // Sync local state with API
  useEffect(() => {
    if (lotItemData) {
      setIsHotSelling(lotItemData.is_hot_selling === 1);
    }
  }, [lotItemData]);

  console.log(lotItemData)

  // Toggle hot selling and call API
  const toggleHotSelling = useCallback(async () => {
    if (!lotItemId) return;

    const newStatus = isHotSelling ? 0 : 1;

    try {
      await updateLot({
        data: {
          inventory_id: inventoryId, // Use inventoryId if API expects it
          id: lotItemId, // include id for your backend
          is_hot_selling: newStatus,
        },
      }).unwrap();

      setIsHotSelling(newStatus === 1);
      toast.success("Hot selling status updated!");
    } catch (err) {
      console.error(err);
      toast.error("Failed to update hot selling status.");
    }
  }, [isHotSelling, inventoryId, lotItemId, updateLot]);

  return (
    <div className={classes.box}>
      <div className={classes.box__head}>
        <div className={classes.box__head__content}>
          <h1 className={classes.box__head__content__title}>
            {`Seller ID: ${lotItemData?.seller_id}`}
          </h1>
          <h1 className={classes.box__head__content__title}>
            {`Inventory ID: ${inventoryId}`}
          </h1>
          <h1 className={classes.box__head__content__title}>
            {`Product ID: ${lotItemId}`}
          </h1>
          <ImageStatusBadge status={lotItemData?.image_exist} />
        </div>

        
      </div>

      <LotDetailForm initialValues={lotItemData} />
    </div>
  );
};
